import { Row, Col } from "antd";
import { useNavigate, useLocation } from "react-router-dom";
import { PrimaryButton } from "../../styled/Button.styled";
import BookingDetails from "./BookingDetails";

const EditBooking = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const onClose = () => {
    const urlParams = new URLSearchParams(location.search);
    const page = urlParams.get('page') || '1';
    navigate(`/bookings?page=${page}`);
  };
  return (
    <>
      <Row justify="end" gutter={20} className="button-bottom-margin">
        <Col>
          <PrimaryButton onClick={onClose}>Back</PrimaryButton>
        </Col>
      </Row>
      
      <BookingDetails />
    </>
  );
};
export default EditBooking;